export const styles = {
  sidebar: {
    width: "80px",

    background: "#000000",
    borderRadius: "20px",
  },
  ul: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    listStyleType: "none",
    gap: "10px",
    marginTop: "110px",
  },
  active: {
    background: "#fff",
    width: "100%",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px 0px",

    borderRadius: "12px 0px 0px 12px",
    marginLeft: "20px",
    paddingRight: "20px",
  },
  inactive: {
    background: "#000000",

    display: "flex",
    width: "100%",

    alignItems: "center",
    justifyContent: "center",
    padding: "20px 0px",

    borderRadius: "12px 0px 0px 12px",
    marginLeft: "20px",
    paddingRight: "20px",
  },
  icon: {
    height: "35px",
    width: "35px",
  },
  navbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "25px",
    flexWrap: "wrap",
  },

  profileBox: {
    display: "flex",
    justifyContent: "end",
    border: "1px solid #86D1BB",
    background: "#F0F0F0",
    mt: 2,
    borderRadius: 3,
  },
  pointerAvatar: {
    "&:hover": {
      cursor: "pointer",
    },
    width: 55,
    height: 55,
  },
  boldMY4: {
    fontFamily: "Inter",
    fontSize: 16,
    color: "#232323",
    fontWeight: "500",
    px: 1,
  },
  boldMY3: {
    fontFamily: "Inter",
    fontSize: 16,
    color: "#232323",
    px: 1,
  },
  pointer: {
    cursor: "pointer",
  },
};
